/* Auto-generated — run: node scripts/build-broomfield-progress.mjs */

import type { ProgressCarouselItem } from '../components/ProgressStageCarousel';

export type BroomfieldProgressStage = {
  date: string;
  title: string;
  items: ProgressCarouselItem[];
};

export const BROOMFIELD_PROGRESS_STAGES: BroomfieldProgressStage[] = [
  {
    "date": "March 2026",
    "title": "Windows and Plastering",
    "items": [
      {
        "src": "/progress/broomfield/16-windows-and-plastering/000.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/001.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/002.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/003.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/004.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/005.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/006.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/007.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/008.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/009.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/010.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/011.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/012.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/013.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/014.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/015.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/016.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/017.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/018.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/019.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/020.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/021.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/16-windows-and-plastering/022.jpg",
        "type": "image"
      }
    ]
  },
  {
    "date": "February 2026",
    "title": "Dry Lining Commencement",
    "items": [
      {
        "src": "/progress/broomfield/15-dry-lining-commencement/000.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/15-dry-lining-commencement/001.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/15-dry-lining-commencement/002.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/15-dry-lining-commencement/003.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/15-dry-lining-commencement/004.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/15-dry-lining-commencement/005.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/15-dry-lining-commencement/006.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/15-dry-lining-commencement/007.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/15-dry-lining-commencement/008.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/15-dry-lining-commencement/009.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/15-dry-lining-commencement/010.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/15-dry-lining-commencement/011.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/15-dry-lining-commencement/012.jpg",
        "type": "image"
      }
    ]
  },
  {
    "date": "January 2026",
    "title": "MF and M&E",
    "items": [
      {
        "src": "/progress/broomfield/14-mf-and-mande/000.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/14-mf-and-mande/001.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/14-mf-and-mande/002.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/14-mf-and-mande/003.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/14-mf-and-mande/004.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/14-mf-and-mande/005.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/14-mf-and-mande/006.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/14-mf-and-mande/007.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/14-mf-and-mande/008.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/14-mf-and-mande/009.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/14-mf-and-mande/010.jpg",
        "type": "image"
      }
    ]
  },
  {
    "date": "January 2026",
    "title": "Contractors Virtual Tour",
    "items": [
      {
        "src": "/progress/broomfield/13-contractors-virtual-tour/000.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/13-contractors-virtual-tour/001.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/13-contractors-virtual-tour/002.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/13-contractors-virtual-tour/003.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/13-contractors-virtual-tour/004.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/13-contractors-virtual-tour/005.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/13-contractors-virtual-tour/006.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/13-contractors-virtual-tour/007.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/13-contractors-virtual-tour/008.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/13-contractors-virtual-tour/009.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/13-contractors-virtual-tour/010.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/13-contractors-virtual-tour/011.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/13-contractors-virtual-tour/012.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/13-contractors-virtual-tour/013.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/13-contractors-virtual-tour/014.jpg",
        "type": "image"
      }
    ]
  },
  {
    "date": "December 2025",
    "title": "Show Suite 1st Fix Sign Off",
    "items": [
      {
        "src": "/progress/broomfield/12-show-suite-1st-fix-sign-off/000.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/12-show-suite-1st-fix-sign-off/001.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/12-show-suite-1st-fix-sign-off/002.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/12-show-suite-1st-fix-sign-off/003.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/12-show-suite-1st-fix-sign-off/004.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/12-show-suite-1st-fix-sign-off/005.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/12-show-suite-1st-fix-sign-off/006.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/12-show-suite-1st-fix-sign-off/007.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/12-show-suite-1st-fix-sign-off/008.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/12-show-suite-1st-fix-sign-off/009.jpg",
        "type": "image"
      }
    ]
  },
  {
    "date": "November 2025",
    "title": "M&E Commencement",
    "items": [
      {
        "src": "/progress/broomfield/11-mande-commencement/000.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/11-mande-commencement/001.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/11-mande-commencement/002.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/11-mande-commencement/003.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/11-mande-commencement/004.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/11-mande-commencement/005.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/11-mande-commencement/006.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/11-mande-commencement/007.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/11-mande-commencement/008.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/11-mande-commencement/009.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/11-mande-commencement/010.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/11-mande-commencement/011.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/11-mande-commencement/012.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/11-mande-commencement/013.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/11-mande-commencement/014.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/11-mande-commencement/015.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/11-mande-commencement/016.jpg",
        "type": "image"
      }
    ]
  },
  {
    "date": "August 2025",
    "title": "Facing Brickwork and Roofing",
    "items": [
      {
        "src": "/progress/broomfield/10-facing-brickwork-and-roofing/000.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/10-facing-brickwork-and-roofing/001.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/10-facing-brickwork-and-roofing/002.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/10-facing-brickwork-and-roofing/003.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/10-facing-brickwork-and-roofing/004.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/10-facing-brickwork-and-roofing/005.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/10-facing-brickwork-and-roofing/006.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/10-facing-brickwork-and-roofing/007.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/10-facing-brickwork-and-roofing/008.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/10-facing-brickwork-and-roofing/009.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/10-facing-brickwork-and-roofing/010.jpg",
        "type": "image"
      }
    ]
  },
  {
    "date": "July 2025",
    "title": "Commencement of Masonry",
    "items": [
      {
        "src": "/progress/broomfield/09-commencement-of-masonry/000.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/09-commencement-of-masonry/001.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/09-commencement-of-masonry/002.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/09-commencement-of-masonry/003.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/09-commencement-of-masonry/004.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/09-commencement-of-masonry/005.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/09-commencement-of-masonry/006.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/09-commencement-of-masonry/007.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/09-commencement-of-masonry/008.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/09-commencement-of-masonry/009.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/09-commencement-of-masonry/010.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/09-commencement-of-masonry/011.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/09-commencement-of-masonry/012.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/09-commencement-of-masonry/013.jpg",
        "type": "image"
      }
    ]
  },
  {
    "date": "June 2025",
    "title": "Drone Footage",
    "items": [
      {
        "src": "/progress/broomfield/08-drone-footage/000.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/08-drone-footage/001.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/08-drone-footage/002.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/08-drone-footage/003.jpg",
        "type": "image"
      }
    ]
  },
  {
    "date": "June 2025",
    "title": "Roof Level Over Retail",
    "items": [
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/000.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/001.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/002.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/003.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/004.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/005.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/006.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/007.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/008.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/009.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/010.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/011.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/012.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/013.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/014.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/015.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/016.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/017.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/018.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/019.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/020.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/07-roof-level-over-retail/021.jpg",
        "type": "image"
      }
    ]
  },
  {
    "date": "May 2025",
    "title": "Striking Formwork",
    "items": [
      {
        "src": "/progress/broomfield/06-striking-formwork/000.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/06-striking-formwork/001.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/06-striking-formwork/002.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/06-striking-formwork/003.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/06-striking-formwork/004.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/06-striking-formwork/005.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/06-striking-formwork/006.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/06-striking-formwork/007.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/06-striking-formwork/008.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/06-striking-formwork/009.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/06-striking-formwork/010.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/06-striking-formwork/011.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/06-striking-formwork/012.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/06-striking-formwork/013.jpg",
        "type": "image"
      }
    ]
  },
  {
    "date": "April 2025",
    "title": "Concrete Framing",
    "items": [
      {
        "src": "/progress/broomfield/05-concrete-framing/000.mp4",
        "type": "video"
      },
      {
        "src": "/progress/broomfield/05-concrete-framing/001.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/05-concrete-framing/002.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/05-concrete-framing/003.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/05-concrete-framing/004.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/05-concrete-framing/005.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/05-concrete-framing/006.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/05-concrete-framing/007.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/05-concrete-framing/008.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/05-concrete-framing/009.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/05-concrete-framing/010.jpg",
        "type": "image"
      }
    ]
  },
  {
    "date": "March 2025",
    "title": "Crane and Concrete Framing Start",
    "items": [
      {
        "src": "/progress/broomfield/04-crane-and-concrete-framing-start/000.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/04-crane-and-concrete-framing-start/001.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/04-crane-and-concrete-framing-start/002.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/04-crane-and-concrete-framing-start/003.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/04-crane-and-concrete-framing-start/004.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/04-crane-and-concrete-framing-start/005.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/04-crane-and-concrete-framing-start/006.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/04-crane-and-concrete-framing-start/007.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/04-crane-and-concrete-framing-start/008.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/04-crane-and-concrete-framing-start/009.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/04-crane-and-concrete-framing-start/010.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/04-crane-and-concrete-framing-start/011.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/04-crane-and-concrete-framing-start/012.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/04-crane-and-concrete-framing-start/013.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/04-crane-and-concrete-framing-start/014.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/04-crane-and-concrete-framing-start/015.mp4",
        "type": "video"
      }
    ]
  },
  {
    "date": "January 2025",
    "title": "Hydrotherapy Pool Rebar",
    "items": [
      {
        "src": "/progress/broomfield/03-hydrotherapy-pool-rebar/000.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/03-hydrotherapy-pool-rebar/001.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/03-hydrotherapy-pool-rebar/002.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/03-hydrotherapy-pool-rebar/003.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/03-hydrotherapy-pool-rebar/004.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/03-hydrotherapy-pool-rebar/005.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/03-hydrotherapy-pool-rebar/006.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/03-hydrotherapy-pool-rebar/007.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/03-hydrotherapy-pool-rebar/008.jpg",
        "type": "image"
      }
    ]
  },
  {
    "date": "December 2024",
    "title": "Basement Works",
    "items": [
      {
        "src": "/progress/broomfield/02-basement-works/000.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/02-basement-works/001.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/02-basement-works/002.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/02-basement-works/003.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/02-basement-works/004.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/02-basement-works/005.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/02-basement-works/006.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/02-basement-works/007.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/02-basement-works/008.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/02-basement-works/009.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/02-basement-works/010.jpg",
        "type": "image"
      }
    ]
  },
  {
    "date": "November 2024",
    "title": "Breaking Ground",
    "items": [
      {
        "src": "/progress/broomfield/01-breaking-ground/000.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/01-breaking-ground/001.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/01-breaking-ground/002.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/01-breaking-ground/003.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/01-breaking-ground/004.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/01-breaking-ground/005.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/01-breaking-ground/006.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/01-breaking-ground/007.jpg",
        "type": "image"
      },
      {
        "src": "/progress/broomfield/01-breaking-ground/008.jpg",
        "type": "image"
      }
    ]
  },
  {
    "date": "October 2024",
    "title": "Pre-Contract Meeting with Natta",
    "items": [
      {
        "src": "/progress/broomfield/00-01-10-24-pre-contract-meeting-with-natta/000.jpg",
        "type": "image"
      }
    ]
  }
];
